import Swiper from 'swiper/bundle';

$(document).ready(function () {

window.Swiper = Swiper;

  var mySwiper = new Swiper('.post-list', {
      speed: 300,
      grabCursor: true,
      spaceBetween: 32,

      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },

      breakpoints: {

       300: {
         slidesPerView: 1,
       },

       768: {
         slidesPerView: 3,
       },

       1200: {
         slidesPerView: 4,
       }
     }
  });

});
